

// import {
//   FETCH_ATTENDANCE_REQUEST,
//   FETCH_ATTENDANCE_SUCCESS,
//   FETCH_ATTENDANCE_FAILURE,
//   DELETE_ATTENDANCE_REQUEST,
//   DELETE_ATTENDANCE_SUCCESS,
//   DELETE_ATTENDANCE_FAILURE,
// } from "../actions/attendanceActions";

// const initialState = {
//   attendance: [],
//   pagination: {
//     currentPage: 1,
//     totalPages: 1,
//     totalRecords: 0,
//     limit: 10,
//   },
//   loading: false,
//   error: null,
// };

// const attendanceReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_ATTENDANCE_REQUEST:
//     case DELETE_ATTENDANCE_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_ATTENDANCE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         attendance: action.payload.attendance,
//         pagination: action.payload.pagination,
//       };

//     case DELETE_ATTENDANCE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         attendance: state.attendance.filter(item => item.id !== action.payload),
//       };

//     case FETCH_ATTENDANCE_FAILURE:
//     case DELETE_ATTENDANCE_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default attendanceReducer;


import {
  FETCH_ATTENDANCE_REQUEST,
  FETCH_ATTENDANCE_SUCCESS,
  FETCH_ATTENDANCE_FAILURE,

  DELETE_ATTENDANCE_REQUEST,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_FAILURE,

  DIRECT_CHECKIN_REQUEST,
  DIRECT_CHECKIN_SUCCESS,
  DIRECT_CHECKIN_FAILURE,

  DIRECT_CHECKOUT_REQUEST,
  DIRECT_CHECKOUT_SUCCESS,
  DIRECT_CHECKOUT_FAILURE,

} from "../actions/attendanceActions";

const initialState = {
  attendance: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
  },
  loading: false,
  error: null,
  successMessage: null, // ✅ Added
};

const attendanceReducer = (state = initialState, action) => {
  switch (action.type) {

    // ================= FETCH =================
    case FETCH_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendance: action.payload.attendance,
        pagination: action.payload.pagination,
      };

    case FETCH_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    // ================= DELETE =================
    case DELETE_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendance: state.attendance.filter(
          (item) => item.id !== action.payload
        ),
      };

    case DELETE_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    // ================= DIRECT CHECK-IN =================
    case DIRECT_CHECKIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case DIRECT_CHECKIN_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload?.meta?.message || "Check-in successful",
      };

    case DIRECT_CHECKIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    // ================= DIRECT CHECK-OUT =================
    case DIRECT_CHECKOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case DIRECT_CHECKOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload?.meta?.message || "Check-out successful",
      };

    case DIRECT_CHECKOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    default:
      return state;
  }
};

export default attendanceReducer;